import {
    BiCalendar, BiPrinter, BiDollar, BiTime, BiCreditCard,
    BiExport, BiCheck, BiRefresh, BiFile, BiUser, BiUndo, BiX
} from "react-icons/bi";
import { PERMISSIONS } from "constants/permission";
import { ViolationStatus, ViolationSituation } from "services/trafficViolationService";
import { ROUTES } from "../../../constants/routes-path";

export const TrafficViolationSpecificActions = (t, navigate, handlePrintAit, handlePrintNa, handlePrintNp, handleUndoCancel, handleUndoDefer) => [
    {
        label: t("traffic-violation.list.table.actions.changes-dates"),
        permissions: [PERMISSIONS.CHANGE_NA_NP_DATES],
        icon: <BiCalendar />,
        visible: (row) => row.show,
        onClick: ({ original }) => alert(`canChangeDates: ${original?.numero_ait}`),
    },
    {
        label: t("traffic-violation.list.table.actions.print-ait"),
        permissions: [PERMISSIONS.PRINT_AIT, PERMISSIONS.AGENT_VIOLATION_QUERY],
        icon: <BiPrinter />,
        visible: (row) =>
            row.original.status === ViolationStatus.VALIDATED.value ||
            row.original.status === ViolationStatus.NOT_VALIDATED.value,
        onClick: ({ original }) => handlePrintAit(original.id),
    },
    {
        label: t("traffic-violation.list.table.actions.print-na"),
        permissions: [PERMISSIONS.VIOLATION_QUERY],
        icon: <BiPrinter />,
        visible: (row) => row.original.situacao === t(`traffic-violation.labels.situation.${ViolationSituation.NA_GENERATED.labelKey}`),
        onClick: ({ original }) => handlePrintNa(original.id),
    },
    {
        label: t("traffic-violation.list.table.actions.print-na-cover"),
        permissions: [PERMISSIONS.VIOLATION_QUERY],
        icon: <BiPrinter />,
        visible: (row) => row.show,
        onClick: ({ original }) => alert(`print NA with cover: ${original?.numero_ait}`),
    },
    {
        label: t("traffic-violation.list.table.actions.print-np-paid"),
        permissions: [PERMISSIONS.VIOLATION_QUERY],
        icon: <BiDollar />,
        visible: (row) => row.show,
        onClick: ({ original }) => alert(`print NP paid: ${original?.numero_ait}`),
    },
    {
        label: t("traffic-violation.list.table.actions.print-np"),
        permissions: [PERMISSIONS.VIOLATION_QUERY],
        icon: <BiPrinter />,
        visible: (row) =>
            row.original.situacao === t(`traffic-violation.labels.situation.${ViolationSituation.NP_GENERATED.labelKey}`),
        onClick: ({ original }) => handlePrintNp(original.id),
    },
    {
        label: t("traffic-violation.list.table.actions.print-np-cover"),
        permissions: [PERMISSIONS.VIOLATION_QUERY],
        icon: <BiPrinter />,
        visible: (row) => row.show,
        onClick: ({ original }) => alert(`print NP with cover: ${original?.numero_ait}`),
    },
    {
        label: t("traffic-violation.list.table.actions.print-np-discount"),
        permissions: [PERMISSIONS.VIOLATION_PAYMENT_DISCOUNTS],
        icon: <BiDollar />,
        visible: (row) => row.show,
        onClick: ({ original }) => alert(`print NP with discount: ${original?.numero_ait}`),
    },
    {
        label: t("traffic-violation.list.table.actions.anticipate-np"),
        permissions: [PERMISSIONS.ANTICIPATE_PENALTY_NOTIFICATIONS],
        icon: <BiTime />,
        visible: (row) => row.show,
        onClick: ({ original }) => alert(`anticipate NP: ${original?.numero_ait}`),
    },
    {
        label: t("traffic-violation.list.table.actions.cancel"),
        permissions: [PERMISSIONS.VIOLATION_CANCEL],
        icon: <BiX />,
        visible: (row) =>
            row.original.situacao === t(`traffic-violation.labels.situation.${ViolationSituation.NA_GENERATED.labelKey}`) ||
            row.original.situacao === t(`traffic-violation.labels.situation.${ViolationSituation.NP_GENERATED.labelKey}`),
        onClick: ({ original }) => {
            navigate(ROUTES.trafficViolationsCancelPath.replace(":id", original?.id));
        },
    },
    {
        label: t("traffic-violation.list.table.actions.confirm-payment"),
        icon: <BiCreditCard />,
        visible: (row) => row.show,
        onClick: ({ original }) => alert(`confirm payment: ${original?.numero_ait}`),
    },
    {
        label: t("traffic-violation.list.table.actions.export-cancellation"),
        permissions: [PERMISSIONS.VIOLATION_CANCEL],
        icon: <BiExport />,
        visible: (row) => row.show,
        onClick: ({ original }) => alert(`export cancellation: ${original?.numero_ait}`),
    },
    {
        label: t("traffic-violation.list.table.actions.defer"),
        permissions: [PERMISSIONS.VIOLATION_APPROVE],
        icon: <BiCheck />,
        visible: (row) =>
            row.original.situacao === t(`traffic-violation.labels.situation.${ViolationSituation.NA_GENERATED.labelKey}`) ||
            row.original.situacao === t(`traffic-violation.labels.situation.${ViolationSituation.NP_GENERATED.labelKey}`),
        onClick: ({ original }) =>
            navigate(ROUTES.trafficViolationsDeferPath.replace(":id", original?.id)),
    },
    {
        label: t("traffic-violation.list.table.actions.export-deferment"),
        permissions: [PERMISSIONS.VIOLATION_APPROVE],
        icon: <BiExport />,
        visible: (row) => row.show,
        onClick: ({ original }) => alert(`export deferment: ${original?.numero_ait}`),
    },
    {
        label: t("traffic-violation.list.table.actions.sync-radar"),
        permissions: [PERMISSIONS.VIOLATION_QUERY],
        icon: <BiRefresh />,
        visible: (row) => row.show,
        onClick: ({ original }) => alert(`sync with radar: ${original?.numero_ait}`),
    },
    {
        label: t("traffic-violation.list.table.actions.sync-payment-detran"),
        icon: <BiRefresh />,
        visible: (row) => row.show,
        onClick: ({ original }) => alert(`sync payment DETRAN: ${original?.numero_ait}`),
    },
    {
        label: t("traffic-violation.list.table.actions.sync-ait-denatran"),
        icon: <BiRefresh />,
        visible: (row) => row.show,
        onClick: ({ original }) => alert(`sync AIT DENATRAN: ${original?.numero_ait}`),
    },
    {
        label: t("traffic-violation.list.table.actions.documents"),
        permissions: [PERMISSIONS.VIOLATION_DOCUMENTS],
        icon: <BiFile />,
        visible: (row) => true,
        onClick: ({ original }) => {
            const url = `${ROUTES.trafficViolationsDocumentsPath}/?parent_id=${original.id}`;
            window.open(url, "_blank");
        },
    },
    {
        label: t("traffic-violation.list.table.actions.indicate-driver"),
        permissions: [PERMISSIONS.VIOLATION_DRIVER_INDICATION],
        icon: <BiUser />,
        visible: (row) =>
            row.original.is_valid && row.original.is_driver_informable,
        onClick: ({ original }) => {
            navigate(ROUTES.trafficViolationInformDriverPath.replace(":id", original?.id));
        },
    },
    {
        label: t("traffic-violation.list.table.actions.undo-payment-confirmation"),
        icon: <BiUndo />,
        visible: (row) => row.show,
        onClick: ({ original }) => alert(`undo payment confirmation: ${original?.numero_ait}`),
    },
    {
        label: t("traffic-violation.list.table.actions.undo-cancellation"),
        icon: <BiUndo />,
        visible: (row) => row.original.has_unrestricted_access && (row.original.motivo_cancelamento || row.original.origem_importacao === "RADAR" || row.original.status === "CANCELADA"),
        onClick: ({ original }) => handleUndoCancel(original.id),
    },
    {
        label: t("traffic-violation.list.table.actions.undo-deferment"),
        icon: <BiUndo />,
        visible: (row) => row.original.has_unrestricted_access && row.original.motivo_deferimento,
        onClick: ({ original }) => handleUndoDefer(original.id),
    },
];
